module.exports = __webpack_public_path__ + "static/img/021_6.abc075f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/021_6.jpg
// module id = aa2X
// module chunks = 1